import { lazy } from 'react';

const ApiKeysPage = lazy(() => import('./pages/ApiKeysPage.jsx'));

const moduleDef = {
  name: 'api',
  routes: [
    { path: '/api-keys', element: ApiKeysPage, permission: 'api.view' },
  ],
  menu: [
    { path: '/api-keys', label: 'API', icon: 'Api', order: 900, permission: 'api.view' },
  ],
  providers: [],
};

export default moduleDef;
